// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import WalletIcon from "@material-ui/icons/Flight";

import DashboardPage from "views/Dashboard/Dashboard.jsx";
import AirlinePaymentPage from "views/AirlinePayment/Index.jsx";
import SettlementPage from "views/Settlement/Index.jsx";
import BillablePassengers from "views/BillablePassengers/Index.jsx";
import PSCUtilization from "views/PSCUtilization/Index.jsx";
import Audit from "@material-ui/icons/TrackChanges";
import Audits from "views/AuditTrail/Index.jsx";
import NotFound from "views/NotFound/Index.jsx";
import AirlinesPassengerPage from "views/AirlinesPassenger/Index.jsx";
import Reconciliation from "@material-ui/icons/RestorePage";
import ReconciliationPage from "views/Reconciliation/Index.jsx";
import Reports from "layouts/recordsLanding/recordsLanding.jsx";
import WalletReport from "views/WalletReport";
import Settings from "@material-ui/icons/SettingsApplications";
import Email from "@material-ui/icons/Email";
import SettingsPage from "views/Settings/Index.jsx";
import EmailSettings from "views/EmailSettings/Index.jsx";
import Report from "@material-ui/icons/Report";
import Transit from "views/Transit/Index.jsx";
import PDM from "views/PDM/Index.jsx";
import DataEntry from "views/DataEntry/Index.jsx"
import StatementOfAccount from "views/StatementOfAccount/Index.jsx"
import OutstandingSettlementPage from "views/OutstandingSettlement/Index.jsx";




const routes = [
    {
        path: "/landing",
        sidebarName: "Home",
        navbarName: "Home",
        icon: Dashboard,
        component: DashboardPage,
        subMenu: [],
    },
    {
        path: "/",
        sidebarName: "Airline Payment",
        isNotVisible: true,
        navbarName: "Dashboard",
        icon: Passenger,
        subMenu: [],
        component: AirlinePaymentPage
    },
    {
      path: "/app/passenger-data",
      sidebarName: "Passenger Data",
      navbarName: "Airline Passenger Data",
      icon: Passenger,
        subMenu: [],
        component: AirlinesPassengerPage
    },
    {
        path: "/app/airline-payment",
        sidebarName: "Airline Payment",
        navbarName: "Airline Payment Report",
        icon: Flight,
        subMenu: [],
        component: AirlinePaymentPage
    },
    {
        path: "/app/psc-settlement",
        sidebarName: " PSC Settlement",
        navbarName: "PSC Settlement",
        icon: Settlement,
        subMenu: [],
        component: SettlementPage
    },
    {
        path: "/app/outstanding-settlement",
        sidebarName: "Outstanding Settlement",
        navbarName: "Outstanding Settlement",
        icon: Settlement,
          subMenu: [],
          component: OutstandingSettlementPage
      },
    {
        path: "/app/reconciliation",
        sidebarName: "Reconciliation",
        navbarName: "Reconciliation",
        icon: Reconciliation,
        component: ReconciliationPage,
        subMenu: []
    },
    // {
    //   path: "/reports-landing",
    //   sidebarName: "PSC Reports",
    //   navbarName: "Psc Reports",
    //   icon: Report,
    //   component: Reports,
    //     subMenu: [],

    // },
    {
        path: "/app/psc-utilization",
        sidebarName: "PSC Utilization",
        isNotVisible: true,
        navbarName: "PSC Utilization",
        icon: Dashboard,
        component: PSCUtilization,
        subMenu: [],

    },
    {
        path: "/app/billable-passengers",
        sidebarName: "Billable Passengers",
        isNotVisible: true,
        navbarName: "Total Passengers vs Billable Passengers",
        icon: BillablePassengers,
        component: BillablePassengers,
        subMenu: [],

    },
    {
        path: "/app/statement-of-account",
        sidebarName: "Account Statement",
        isNotVisible: true,
        navbarName: "Account Statement",
        icon: Reconciliation,
        component: StatementOfAccount,
        subMenu: []
    },
    {
        path: "/app/audits",
        sidebarName: "Audit Trail",
        navbarName: "Audit Trails",
        isNotVisible: true,
        icon: Audit,
        subMenu: [],
        component: Audits,
    },
    {
        path: "/app/wallet-report",
        sidebarName: "Airline Wallet Report",
        isNotVisible: true,
        navbarName: "Airline Wallet Report",
        icon: WalletIcon,
        component: WalletReport,
        subMenu: [],

    },
    {
        path: "/app/transit-passenger-report",
        sidebarName: "Transit Report",
        navbarName: "Transit Report",
        icon: Reconciliation,
        component: Transit,
        isNotVisible: true,
        subMenu: []
    },
    {
        path: "/reports-landing",
        sidebarName: "PSC Reports",
        navbarName: "Psc Reports",
        icon: Report,
        component: Reports,
        subMenu: [],

    },
    {
        path: "/app/settings",
        sidebarName: "Settings",
        navbarName: "Settings",
        subMenu: [
            {
                path: "/app/settings",
                sidebarName: "Re-order Level",
                navbarName: "Re-order Level",
                component: SettingsPage
            },
            {
                path: "/app/emailSettings",
                sidebarName: "Email Settings",
                navbarName: "Email Settings",
                icon: Email,
                component: EmailSettings
            },
        ],
        icon: Settings,
        component: SettingsPage
    },
    {
        path: "/app/emailSettings",
        sidebarName: "Email Settings",
        navbarName: "Email Settings",
        icon: Email,
        isNotVisible: true,
        component: EmailSettings,
        subMenu: [],

    },
    {
        path: "/app/dataEntry",
        sidebarName: "Data Entry",
        navbarName: "Data Entry",
        icon: Reconciliation,
        component: DataEntry,
        subMenu: [],

    },
    {
        path: "/app/pdm",
        sidebarName: "PDM",
        navbarName: "PDM",
        icon: Reconciliation,
        component: PDM,
        subMenu: [],

    },
    {
        path: "/app",
        sidebarName: "Dashboard",
        isNotVisible: true,
        navbarName: "Dashboard",
        icon: Dashboard,
        subMenu: [],
        component: DashboardPage
    },
    {
        path: "/app/dashboard",
        sidebarName: "Dashboard",
        isNotVisible: true,
        navbarName: "Dashboard",
        icon: Dashboard,
        subMenu: [],
        component: DashboardPage
    },
    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/airportManager.jsx